import { Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const BOOKING_URL = "https://home.shortcutssoftware.com/ah#/_h/sites/6509/details";

const beautyCategories = [
  {
    title: 'Beauty Essentials',
    services: [
      { name: 'Eyebrow Waxing: Clean Up', price: '$30' },
      { name: 'Eyebrow Precision Shaping', price: '$35' },
      { name: 'Lip Wax or Spot Area', price: '$45' },
      { name: 'Underarms', price: '$45' },
      { name: 'Eyebrow & Lash Tinting', price: '$55' },
      { name: 'Eyebrow Or Lash Tinting', price: '$37 each' },
    ]
  },
  {
    title: 'Artistry Facials',
    services: [
      { name: 'The Teen & Intro Reset', price: '$120' },
      { name: 'Calm & Hydrate (Sensitive)', price: '$145' },
      { name: 'The Signature Pamper Peel', price: '$165' },
      { name: 'The Clinical Transformation (Fine Lines & Wrinkles)', price: '$188' },
      { name: 'Luminous Correction (Pigmentation)', price: '$212' },
    ]
  },
  {
    title: 'Microdermabrasion',
    services: [
      { name: 'Express Micro', price: '$99' },
      { name: 'Deluxe Micro', price: '$144' },
      { name: 'LED Light Therapy Add-On', price: '$55' },
    ]
  },
  {
    title: 'LED Light Therapy',
    services: [
      { name: 'LED Light Therapy Facial', price: '$145' },
      { name: 'LED Light Therapy Express', price: '$77' },
      { name: 'The Eczema Relief Area Session', price: '$65' },
      { name: '20-Minute Nervous System Reset', price: '$122' },
      { name: 'The 9-Session Protocol', price: '$991', note: 'Clinically tested intensive cycle — skin stabilised for up to 3 months' },
    ]
  },
  {
    title: 'Waterfall Head Spa',
    services: [
      { name: 'Artisan Waterfall Head Spa (60 min)', price: '$195' },
      { name: 'Signature Artisan Head Spa (90 min)', price: '$233' },
      { name: 'Add-On: Hydration Eye Pads', price: '$20' },
      { name: 'Add-On: Targeted LED Therapy', price: '$45' },
      { name: 'Add-On: Face Hydration Capsules', price: '$20' },
    ]
  },
  {
    title: 'Waterfall Head Spa — Targeted Scalp Protocols',
    services: [
      { name: 'The Vitality Anchor (Hair Loss & Thinning)', price: 'Included' },
      { name: 'The Pure Balance (Oily & Sweaty Scalp)', price: 'Included' },
      { name: 'The Dewy Calm (Dry & Sensitive Scalp)', price: 'Included' },
      { name: 'The Clarity Reset (Dandruff & Flaking)', price: 'Included' },
    ]
  },
  {
    title: 'Super Hair Removal',
    services: [
      { name: 'Small Areas (Lip, Chin, Underarms)', price: '$35 – $55' },
      { name: 'Medium Areas (Half Leg, Arms, Bikini)', price: '$85 – $130' },
      { name: 'Large Areas (Full Leg, Back, Chest)', price: '$195 – $260' },
    ]
  },
  {
    title: 'HIFU Non-Surgical Face & Body Lift',
    services: [
      { name: 'HIFU Treatment', price: 'Consultation Required', note: 'Non-invasive lifting — no needles, no surgery, zero downtime' },
    ]
  },
  {
    title: 'Packages',
    services: [
      { name: 'The "Radiant Transition" Bundle (3-Month Intensive)', price: '$385', note: 'Save $100+ — Includes 3x Facials + 1x Complimentary LED session' },
      { name: 'The 90-Day Blueprint', price: '$1,150', note: 'Save $500+ — 9x Omnilux LED sessions & 3x Performance Treatments' },
    ]
  },
  {
    title: 'Coming Soon',
    services: [
      { name: 'Cosmetic Nurse', price: 'TBA' },
      { name: 'Tattoo Removal Sessions', price: 'TBA' },
      { name: 'Cosmetic Tattoo for Eyebrows & More', price: 'TBA' },
    ]
  },
];

export default function BeautyPriceList() {
  return (
    <main className="min-h-screen bg-[#FFFDF9]" data-testid="beauty-pricelist-page">
      <SEO page="beautyPriceList" />

      {/* Hero */}
      <section className="pt-32 pb-12 md:pt-40 md:pb-16 text-center">
        <div className="max-w-[1000px] mx-auto px-6">
          <h1 className="text-5xl md:text-7xl font-light text-[#2C2420] tracking-wide mb-6">
            Beauty Price List
          </h1>
          <p className="text-lg text-[#6B5D4D] mb-8">
            Skin treatments, facials, LED therapy, laser hair removal & more.
          </p>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
            <Button className="bg-[#8D7B68] hover:bg-[#6B5D4D] text-white rounded-full px-8 py-4 text-base" data-testid="beauty-price-book-btn">
              <Calendar className="w-5 h-5 mr-2" />
              Book Appointment
            </Button>
          </a>
        </div>
      </section>

      {/* Price Tables */}
      <section className="py-12" data-testid="beauty-price-tables">
        <div className="max-w-[800px] mx-auto px-6">
          {beautyCategories.map((category) => (
            <div key={category.title} className="mb-10">
              <h3 className="text-xl md:text-2xl font-light text-[#2C2420] mb-3 pb-2 border-b-2 border-[#2C2420]">
                {category.title}
              </h3>
              <table className="w-full">
                <tbody>
                  {category.services.map((service, idx) => (
                    <tr
                      key={service.name}
                      className={`border-b border-[#E8DED2] ${idx % 2 === 0 ? 'bg-white' : 'bg-[#FDFBF9]'}`}
                    >
                      <td className="py-3 pr-4">
                        <p className="text-sm text-[#2C2420]">{service.name}</p>
                        {service.note && (
                          <p className="text-xs text-[#8D7B68] mt-0.5">{service.note}</p>
                        )}
                      </td>
                      <td className="py-3 text-right text-sm text-[#6B5D4D] whitespace-nowrap font-medium">
                        {service.price}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}

          <div className="mt-8 p-6 bg-[#F5F0EB] rounded-lg text-center">
            <p className="text-sm text-[#6B5D4D]">
              All prices are subject to change. Consultation required for HIFU treatments.
            </p>
          </div>

          <div className="mt-12 text-center">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              <Button className="bg-[#2C2420] hover:bg-[#1a1512] text-white rounded-full px-10 py-5 text-base">
                Book Your Appointment
              </Button>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
